import { Paper } from "@material-ui/core"
import type { ReactElement, ReactNode } from "react"

import "./map-control.styles.scss"

export interface IMapControlProps {
  className?: string
  children?: ReactNode
}

export function MapControl(props: IMapControlProps): ReactElement {
  const { className, children } = props

  return (
    <Paper
      onDoubleClick={(event) => event.stopPropagation()}
      className={`map-control leaflet-control ${className ? className : ""}`}
    >
      {children}
    </Paper>
  )
}
